import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const GraphContainer = styled.div`
  width: 100%;
  height: 206px;

  .tooltip .tooltiptext::after {
    content: " ";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: black transparent transparent transparent;
  }

  @media (max-width: 768px) {
    height: 280px;
  }
`;

export const EnergyGraphContainer = styled.div`
  width: 100%;
`;

export const FooterContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;

  h2, p {
    color: ${colors.text['main-900']};
    font-weight: 700;
    margin: 0;
  }

  h2 {
    font-size: 11px;
    color: ${colors.text['main-900']};
  }

  p {
    font-size: 16px;
  }

  span {
    font-weight: 300;
    font-size: 16px;
    color: ${colors.GreyDark};
  }

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`;

export const FooterItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  & > div {
    display: flex;
    gap: 8px;
  }
`;

export const DeltaInfo = styled.div<{redPercentage?: boolean}>`
  display: flex;
  align-items: center;
  gap: 2px;

  span {
    margin: 0;
    font-size: 9px;
    font-weight: 700;
    color: ${({ redPercentage }) => (redPercentage ? colors.state.danger.base : colors.state.success.base)};
  }

`;
